var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSharedMoneyTransfer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000002519"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M25.6999 33.1457C23.3343 34.4632 21.3839 36.1216 11.1791 34.1714C11.1791 25.782 11.1747 25.3789 11.1769 16.9914C22 19.122 24 13.622 36.7956 15.9637C36.7956 19.5452 36.8932 18.1542 36.7956 20.1219",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 147",
    d: "M36.5407 20.1128C33.9984 20.1128 31.9375 18.1892 31.9375 15.8164",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 152",
    d: "M17.2871 17.1038C17.5278 19.584 15.7689 21.7768 13.3585 22.0014C12.7378 22.0592 12.1345 21.9809 11.5765 21.7904",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 153",
    d: "M11.1761 29.1335C13.7184 29.1335 15.7793 31.0571 15.7793 33.4299C15.7793 34.0409 15.6426 34.6222 15.3963 35.1484",
    stroke: "currentColor",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 151",
    cx: 24,
    cy: 25.1211,
    r: 3,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1544",
    d: "M30.3758 35.2296L30.2706 32.2839L33.2751 32.191",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 1545",
    d: "M41.0346 23.9704L41.1735 26.9148L38.1702 27.042",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 222",
    d: "M31.3861 33.1463C32.6271 34.7068 34.6833 35.5621 36.805 35.1979C39.3493 34.7611 41.1856 32.7083 41.4134 30.3031",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 223",
    d: "M40.0488 26.0631C38.7899 24.5169 36.7242 23.6851 34.6067 24.0736C32.0676 24.5395 30.2548 26.6131 30.0546 29.0207",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharedMoneyTransfer);
export default __webpack_public_path__ + "static/media/ic-shared-money-transfer.e45ce4214e4c2cdb29de124aed0bd6c4.svg";
export { ForwardRef as ReactComponent };